//Grouping spaces are cosmetic: the backend stores and matches the IBAN without them.
const normalizeIban = (value) => (value || "").replace(/\s/g, "").toUpperCase();

//ISO 13616: country code, two check digits and up to 30 alphanumerics, verified with the mod-97
//rule. It is the only gate on a bank info now that nothing else confirms the account for us.
const isValidIban = (value) => {
    const iban = normalizeIban(value);
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false;
    const rearranged = iban.slice(4) + iban.slice(0, 4);
    let remainder = 0;
    for (const char of rearranged) {
        //letters count as their position in the alphabet plus 9 (A = 10 … Z = 35)
        const digits = char >= "A" && char <= "Z" ? (char.charCodeAt(0) - 55).toString() : char;
        for (const digit of digits) remainder = (remainder * 10 + Number(digit)) % 97;
    }
    return remainder === 1;
};

export {normalizeIban, isValidIban};
